export default __webpack_public_path__ + "static/media/gallery_10.1e93c021.jpg";